//@ts-check
import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import PageTab from './PageTab';
import fieldLogic from '../logic/fieldsLogic';
import Utils from '../../../../utils';
import Grid from '@material-ui/core/Grid';
/**
 * @param {import('./types').FormTabsProps & import('@material-ui/core').WithStyles} props
 */

var FormTabs = function FormTabs(_ref) {
  var value = _ref.value,
      values = _ref.values,
      dispatch = _ref.dispatch;

  var onChange = function onChange(e, newTab) {
    return fieldLogic.onPageChange(newTab, dispatch);
  };

  return React.createElement(Grid, {
    item: true,
    style: {
      width: '100%'
    }
  }, React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "center",
    alignItems: "stretch",
    style: {
      borderBottom: '1px solid lightgray',
      marginBottom: 20
    }
  }, React.createElement(Grid, {
    item: true,
    style: {
      maxWidth: '100%'
    }
  }, React.createElement(Tabs, {
    value: value,
    onChange: onChange,
    variant: "scrollable",
    scrollButtons: "auto"
  }, values.map(function (val) {
    return React.createElement(PageTab, {
      value: val.id,
      key: val.id,
      caption: val.caption,
      error: val.error
    });
  })))));
};

export default React.memo(FormTabs, function (prevProps, nextProps) {
  return Utils.deepEqual(prevProps, nextProps);
});